<template>
  <NotificationTemplate
    :notification="notification"
    :showSubTitle="false"
  >
    <template #pic>
      <Avatar
        :src="notification.initiatorAvatarSrc || null"
        :gap="notification.getInitials()"
      />
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <template v-if="isMention">You have been mentioned by </template>
        <span class="notification__update-item__initiator">{{
          notification.initiatorFullName
        }}</span>
        {{ actionText }}
        <a
          class="link is-large"
          target="_blank"
          :href="notification.todoUrl"
        >
          ToDo:
        </a>
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        v-if="notification.comment"
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__todo-comment"
      >
        <ReferencedText
          :resetStyle="true"
          :html="notification.comment"
        />
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script setup lang="ts">
import { computed } from "vue"

import Avatar from "@/components/Avatar/index.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"
import { ReferencedText } from "@/components/Reference"

import { NotificationType } from "@/models/Notification/common"
import { NotificationTodo } from "@/models/Notification/NotificationTodo"

const props = defineProps<{
  notification: NotificationTodo
}>()

/** Comment wording differs by the recipient relationship supplied by the backend. */
const isMention = computed(
  () =>
    props.notification.commentActivityType === "MENTION" ||
    props.notification.type === NotificationType.TODO_COMMENT_MENTION
)
const actionText = computed(() => {
  if (props.notification.commentActivityType === "REPLY") {
    return "replied to you in"
  }
  if (props.notification.commentActivityType === "MENTION") {
    return "in"
  }

  switch (props.notification.type) {
    case NotificationType.TODO_COMMENT_REPLY:
      return "replied to you in"
    case NotificationType.TODO_COMMENT_MENTION:
      return "in"
    default:
      return "added a comment to"
  }
})
</script>
